/**
 * Retail & Tea Room screen — a three-tab wrapper:
 *   • Retail and Tea Room Sales (the existing EPOS dashboard, default)
 *   • Resource Bookings (online upsells / bookable-resource add-ons)
 *   • Outlets by Time (exec only — outlet profitability by hour of day)
 *
 * The third tab is only rendered for members of SG-Exec-Reports. That is
 * presentation only: every endpoint behind it independently requires the group
 * server-side, so hiding the button is not what enforces the restriction.
 */
import { useState } from "react";
import { SalesDashboard } from "./SalesDashboard";
import { ResourceBookings } from "./ResourceBookings";
import { ExecOutlets } from "./ExecOutlets";
import { SecondarySpendBox } from "./SecondarySpendBox";
import "./resource-bookings.css";

type Tab = "sales" | "resources" | "exec";

export function SalesScreen({ isExec }: { isExec: boolean }) {
  const [tab, setTab] = useState<Tab>("sales");

  // If access is lost mid-session (group removed, page left open), fall back
  // rather than rendering a tab the API will refuse to serve.
  const active: Tab = tab === "exec" && !isExec ? "sales" : tab;

  return (
    <>
      <div className="sales-screen-tabs" role="tablist" aria-label="Retail & Tea Room">
        <button
          type="button" role="tab" aria-selected={active === "sales"}
          className={"sst-tab" + (active === "sales" ? " active" : "")}
          onClick={() => setTab("sales")}
        >
          Retail and Tea Room Sales
        </button>
        <button
          type="button" role="tab" aria-selected={active === "resources"}
          className={"sst-tab" + (active === "resources" ? " active" : "")}
          onClick={() => setTab("resources")}
        >
          Resource Bookings
        </button>
        {isExec && (
          <button
            type="button" role="tab" aria-selected={active === "exec"}
            className={"sst-tab" + (active === "exec" ? " active" : "")}
            onClick={() => setTab("exec")}
          >
            Outlets by Time
          </button>
        )}
      </div>
      {active === "sales" && <SalesDashboard />}
      {active === "resources" && <ResourceBookings />}
      {active === "exec" && (
        <>
          <div style={{ padding: "16px 16px 0" }}><SecondarySpendBox /></div>
          <ExecOutlets />
        </>
      )}
    </>
  );
}
